module.exports = __webpack_public_path__ + "assets/img/xlwy_b.ae31030f.png";